import React from "react";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import materialUI from "material-UI";
import * as S from "./styles";

interface Props {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  color?: string;
  value: string;
}

const useStyles = materialUI.makeStyles({
  root: {
    color: "#D0D5DD",
    "&.Mui-checked": {
      color: "#2D5BFF",
    },
    "&.Mui-disabled": {
      color: "#B0B0B0",
    },
  },
});

const RadioComponent: React.FC<Props> = ({
  value,
  label,
  checked,
  onChange,
  disabled = false,
  color = "#2D5BFF",
}) => {
  return (
    <FormControlLabel
      control={
        <Radio
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          classes={{ root: useStyles().root }}
          sx={{
            color: "#000000",
            opacity: 0.6,
            "&.Mui-checked": {
              color,
              opacity: 1,
            },
          }}
        />
      }
      label={<S.Label>{label}</S.Label>}
    />
  );
};

export default RadioComponent;
